// extracted by mini-css-extract-plugin
module.exports = {"main":"Yasgui_main__2QBJb","buttonContainer":"Yasgui_buttonContainer__3Nrd0","tableContainer":"Yasgui_tableContainer__36LQd"};